import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api.ts";
import { rel } from "../format.ts";
import { Empty } from "../ui.tsx";

interface Ev { id: string; action: string; entityType: string; entityId: string; createdAt: string; actor: string | null; metadata: Record<string, unknown> | null }

const LABEL: Record<string, string> = {
  "booking.entered_by_staff": "Réservation saisie par l'équipe", "booking.claimed": "Séjour rattaché à un compte",
  "listing.block_added": "Nuits bloquées", "listing.block_removed": "Blocage levé", "guest.edited": "Fiche client modifiée",
};
const pretty = (a: string) => LABEL[a] ?? a.replace(/[._]/g, " ");

export function Activity() {
  const [rows, setRows] = useState<Ev[] | null>(null);
  useEffect(() => { api<Ev[]>("/v1/staff/audit").then(setRows).catch(() => setRows([])); }, []);
  return (
    <section>
      <header className="pagehead"><h1>Journal d'activité</h1><p className="muted small">Qui a fait quoi, et quand. Les 200 derniers événements ; rien ne s'y efface.</p></header>
      {rows && rows.length === 0 && <Empty>Aucune activité.</Empty>}
      <ul className="rows">
        {rows?.map((e) => (
          <li key={e.id} className="kv">
            <span><b>{pretty(e.action)}</b> <span className="muted small">· {e.actor ?? "système"}</span></span>
            <span className="muted small">{e.entityType === "booking" ? <Link className="link" to={`/b/${e.entityId}`}>voir</Link> : null} {rel(e.createdAt)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
